import { createAction } from '@reduxjs/toolkit';

import { getFailurePayloadCreator, getPayloadCreator } from '../core/actionHelpers';
import type { GetPreferencesSuccessPayload, PreferencePath, SetPreferencePayload } from './preferencesTypes';

const failurePayloadCreator = getFailurePayloadCreator<unknown>();
const noPayloadCreator = getPayloadCreator();

export const getPreferences = createAction('GET_PREFERENCES', getPayloadCreator<PreferencePath>());
export const getPreferencesUser = createAction('GET_PREFERENCES_USER', noPayloadCreator);
export const getPreferencesDataset = createAction('GET_PREFERENCES_DATASET', noPayloadCreator);
export const getPreferencesSuccess = createAction(
  'GET_PREFERENCES_SUCCESS',
  getPayloadCreator<GetPreferencesSuccessPayload>(),
);
export const getPreferencesFailure = createAction('GET_PREFERENCES_FAILURE', failurePayloadCreator);

export const setPreference = createAction('SET_PREFERENCE', getPayloadCreator<SetPreferencePayload>());
export const setPreferenceSuccess = createAction('SET_PREFERENCE_SUCCESS', getPayloadCreator<SetPreferencePayload>());
export const setPreferenceFailure = createAction('SET_PREFERENCE_FAILURE', failurePayloadCreator);
